export default "__VITE_ASSET__9Yh_CDuy__"